import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Device, DeviceState } from '@era/locations-sdk';
import { Store } from '@ngrx/store';
import { DeviceStoreSelectors } from '@era/stores';
import { DevicesUnavailableBadgeComponent } from './devices-unavailable-badge.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-devices-unavailable-badge',
  templateUrl: './devices-unavailable-badge.container.html',
  styleUrls: ['./devices-unavailable-badge.container.scss'],
  imports: [DevicesUnavailableBadgeComponent, AsyncPipe],
})
export class DevicesUnavailableBadgeContainerComponent {
  public readonly count$: Observable<number>;

  constructor(private readonly store: Store<Device>) {
    this.count$ = this.store.select(DeviceStoreSelectors.selectDevicesCountByState(DeviceState.Unavailable));
  }
}
